import KeyPair from "protico-encryption/dist/KeyPair";
import { v4 as uuidv4 } from "uuid";
import { TBToCMessage } from "../types/types";

/**
 *
 * @param toAddress
 * @param userKeypair
 * @returns targetPubKey
 * @raise Error(): raise error when the target is not ready for dm
 */

export const generateMessage = (
  fromAddress: string,
  toDomain: string,
  messageText: string,
  logoUrl: string,
) => {
  // TODO: do some error handle of this.encrypt
  const message: TBToCMessage = {
      messageText,
      id: uuidv4(),
      fromAddress: fromAddress,
      toDomain: toDomain,
      sended: false,
      messageType: "c_to_b",
      logoUrl: logoUrl,
  };
  return message;
};
export const encrypt = (
  plaintextMessage: string,
  userKeypair: KeyPair,
  toPubKeyUint8: Uint8Array
) => {
  try {
    return userKeypair.encrypt(toPubKeyUint8, plaintextMessage, true) as string;
  } catch (e) {
    throw new Error("Encrypt fail");
  }
};

export const utilparseMessage = (message: any) => {
  return {
    id: message.id,
    createdAt: message.created_at,
    fromAddress: message.from_address,
    toDomain: message.to_domain || message.to_domain__domain,
    messageType: message.message_type,
    messageText: message.message_text,
    sended: message.sended,
    message_reference: message.message_reference,
    referenced_message: message.referenced_message,
    logoUrl: message.logoUrl,
  } as TBToCMessage;
};
